module.exports = __webpack_public_path__ + "static/media/parkingSpace.e33ec677.svg";